$(document).bind('_js_ready popin', function() {
    $('#bloc_kiosque .content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
        nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
    });
});
